import './common';
import Inputmask from 'inputmask';
import jQuery from 'jquery';
import EasyMDE from "easymde";
import axios from 'axios';
import * as bootstrap from 'bootstrap';
import './front/cookie-banner';
import 'select2';
require('./legacy-plugins/bootstrap-datepicker.min');
window.bootstrap = bootstrap
const FingerprintJS= require('@fingerprintjs/fingerprintjs-pro')
// Initialize an agent at application startup.
window.fpPromise = FingerprintJS.load({ apiKey: process.env.MIX_FINGERPRINT_KEY })
$('document').ready(function () {
    if ($('#fingerprint').length > 0)
    {
        window.fpPromise
            .then(fp => fp.get())
            .then(result =>
                $.ajax({
                    type: "post",
                    url: "/a/visitor-id",
                    data: {fingerprint: result.visitorId},
                    headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
                    success: function (result) {}
                })
            );
    }
});

$('.radio-label').keypress(function (e) {
    if (e.keyCode === 0 || e.keyCode === 32) {
        $(this).find('input').prop('checked', true);
    }
});

$('.checkbox-label').keypress(function (e) {
    if (e.keyCode === 0 || e.keyCode === 32) {
        var $ele = $(this).find('input');
        $ele.prop('checked', !$ele.is(':checked'));
    }
});

//region Side Menu Toggle (hamburger on mobile)
$(document).on('click', '.js-toggle-side-menu', function (event) {
    event.preventDefault();
    let $sideMenu = $('.js-side-menu');
    $sideMenu.toggleClass('open');

    if ($sideMenu.hasClass('open')) {
        $('#js-scrolled-focus-mobile').attr('aria-expanded', 'true');

        $sideMenu.attr('aria-hidden', 'false');
        $sideMenu.find('.side-menu-header').attr('aria-hidden', 'false');
        $sideMenu.find('a').attr('tabindex', '0').attr('aria-hidden', 'false');
        // set modal content exposed to accessibility tree
        $('.js-close-menu').attr('tabindex', '0');
        $('.js-menu-item').attr('tabindex', '0');
        trapKeyboardFocus('#js-side-modal');

    } else {
        $('#js-scrolled-focus-mobile').attr('aria-expanded', 'false');

        $sideMenu.attr('aria-hidden', 'true');
        $sideMenu.find('.side-menu-header').attr('aria-hidden', 'true');
        $sideMenu.find('a').attr('tabindex', '-1').attr('aria-hidden', 'true');
        $('.js-close-menu').attr('tabindex', '-1');
        $('.js-menu-item').attr('tabindex', '-1');
    }
});
// endregion
//
// $('.collapse').on('hide.bs.collapse', function () {
//     $('.accordion-button-icon').removeClass('minus').addClass('plus');
// }).on('show.bs.collapse', function () {
//     $('.accordion-button-icon').removeClass('plus').addClass('minus');
// });
//
// $('.modal').on('show.bs.modal', function () {
//     $('.modal .modal-body').css('overflow-y', 'auto');
//     $('.modal .modal-body').css('max-height', $(window).height() * 0.7);
// });
//
// $(document).on('click', '.js-toggle-cookie-banner', function (event) {
//     event.preventDefault();
//     $('.js-cookie-modal-container').addClass('open');
//
//     if ($('.js-cookie-sidebar').hasClass("hide")) {
//         $('.cookie-modal-overlay').css('z-index', 90);
//     }
// });
//
// // region Cookie Banner
// $(document).ready(function () {
//     let $cookieContainer = $('.js-cookie-modal-container');
//
//     if ($cookieContainer.attr('data-can-open') === 'true') {
//         $cookieContainer.addClass('open');
//         $('body').addClass('open');
//         trapKeyboardFocus('#js-cookie-banner-modal');
//     }
// });
//
// $(document).on('click', '.js-cookie-details', function (event) {
//     event.preventDefault();
//
//     let $cookieBarContainer = $('.js-cookie-sidebar');
//     $cookieBarContainer.removeClass('d-none');
//     $('.js-cookie-modal-container').addClass('show-sidebar');
//     $('.cookie-modal-overlay').css('z-index', 100);
//
//     // when banner is triggered & open, trap focus within for keyboard users (accessibility)
//     $cookieBarContainer.toggleClass('open');
//     if ($cookieBarContainer.hasClass('open')) {
//
//         $cookieBarContainer.removeAttr('aria-hidden');
//         // set modal content exposed to accessibility tree
//         $('.js-close-banner').attr('tabindex', '0').removeAttr('aria-hidden');
//         $('.js-banner-item').attr('tabindex', '0').removeAttr('aria-hidden');
//         trapKeyboardFocus('#js-cookie-banner-sidebar');
//     } else {
//         $cookieBarContainer.find('.js-banner-item').attr('tabindex', '-1').attr('aria-hidden', true);
//         $cookieBarContainer.attr('aria-hidden', true);
//         if (screen.width >= 768) {
//             document.getElementById("js-scrolledfocusdesktop").focus();
//         } else {
//             document.getElementById("js-scrolled-focus-mobile").focus();
//         }
//     }
// });
//
// $(document).on('click', '.js-cookie-details-close', function (event) {
//     event.preventDefault();
//
//     $('.js-cookie-sidebar').addClass('d-none');
//     $('.js-cookie-modal-container').removeClass('show-sidebar');
// });
//
// $(document).on('click', '.js-cookie-sidebar-toggle', function (event) {
//     event.preventDefault();
//
//     let $this = $(this);
//
//     let value = $this.attr('data-value');
//
//     if (value === '0') {
//         $this.removeClass('fa-toggle-off');
//         $this.addClass('fa-toggle-on');
//         $this.attr('data-value', 1);
//     } else {
//         $this.addClass('fa-toggle-off');
//         $this.removeClass('fa-toggle-on');
//         $this.attr('data-value', 0);
//     }
// });
//
// $(document).on('click', '.js-cookie-toggle-details', function (event) {
//     event.preventDefault();
//
//     let category = $(this).attr('data-category');
//
//     $('.js-cookie-sidebar-content-list[data-category="' + category + '"]').removeClass('no-show');
// });
//
// $(document).on('click', '.js-cookie-sidebar-list-hide', function (event) {
//     event.preventDefault();
//
//     $(this).closest('.js-cookie-sidebar-content-list').addClass('no-show');
// });
//
// // change the state of switch checkbox in banner on click
// function toggleCookieSwitch(self) {
//     let state = $(self).attr('aria-checked');
//     let isState = (state === 'true');
//     $(self).attr('aria-checked', !isState)
//     $(self).attr('data-value', !isState ? 1 : 0)
// }
//
// $(document).on('click', '.cookie-sidebar-toggle', function () {
//     toggleCookieSwitch(this);
// });
//
// // change the state of switch checkbox in sidebar on press enter, left or right
// $(document).on('keyup', '.cookie-sidebar-toggle', function (e) {
//     if ((e.keyCode ? e.keyCode : e.which) === 13 || (e.keyCode ? e.keyCode : e.which) === 37 || (e.keyCode ? e.keyCode : e.which) === 39) {
//         $(this).trigger('click');
//     }
// });
//
// $(document).on('click', '.js-cookie-accept-all', function (event) {
//     event.preventDefault();
//
//     $.ajax({
//         method: 'get',
//         url: $('.js-cookie-url').attr('data-url'),
//         dataType: 'json',
//         data: {all: 'true'},
//         headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
//         success: function () {
//             $('.js-cookie-sidebar').addClass('d-none');
//             $('.js-cookie-modal-container').removeClass('open');
//             $('body').removeClass('open');
//             $('.js-accessible-logo').find('a').focus();
//         },
//     });
// });
//
// $(document).on('click', '.js-cookie-save', function (event) {
//     event.preventDefault();
//
//     $.ajax({
//         method: 'get',
//         url: $('.js-cookie-url').attr('data-url'),
//         dataType: 'json',
//         data: {
//             strictly_necessary: $('.js-cookie-sidebar-toggle[data-category="strictly_necessary"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
//             first_party_performance: $('.js-cookie-sidebar-toggle[data-category="first_party_performance"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
//             third_party_performance: $('.js-cookie-sidebar-toggle[data-category="third_party_performance"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
//             functional: $('.js-cookie-sidebar-toggle[data-category="functional"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
//             targeting: $('.js-cookie-sidebar-toggle[data-category="targeting"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
//         },
//         headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
//         success: function () {
//             $('.js-cookie-sidebar').addClass('d-none');
//             $('.js-cookie-modal-container').removeClass('open');
//             $('body').removeClass('open');
//             $('.js-accessible-logo').find('a').focus();
//         },
//     });
// });
//
// $(document).on('click', '.js-cookie-reject', function (event) {
//     event.preventDefault();
//
//     $.ajax({
//         method: 'get',
//         url: $('.js-cookie-url').attr('data-url'),
//         dataType: 'json',
//         data: {
//             strictly_necessary: 'disabled',
//             first_party_performance: 'disabled',
//             third_party_performance: 'disabled',
//             functional: 'disabled',
//             targeting: 'disabled',
//         },
//         headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
//         success: function () {
//             $('.js-cookie-sidebar').addClass('d-none');
//             $('.js-cookie-modal-container').removeClass('open');
//             $('body').removeClass('open');
//             $('.js-accessible-logo').find('a').focus();
//         },
//     });
// });
// // endregion

// region Modal trap keyboard focus function
function trapKeyboardFocus(selector_id) {
    const modal = document.querySelector(selector_id); // select the modal by it's id
    if (!modal) {
        console.error('Modal does not exist: ' + selector_id);
        return;
    }

    // add all the elements inside modal which you want to make focusable
    const focusableElements =
        '[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent = modal.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

    document.addEventListener('keydown', function (e) {
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    });
    firstFocusableElement.focus();
}

// endregion

// region Datepicker
$('.date_picker').datepicker({
    format: "dd-mm-yyyy",
    todayHighlight: true,
    orientation: "bottom auto",
    autoclose: true
});

$(document).ready(function(){
    $('#account_name, #account_number, #account_number_confirmation, #sort_code, #sort_code_confirmation').on("cut copy paste",function(e) {
        e.preventDefault();
    });
});

$(".file-trigger").click(function(e) {
    e.preventDefault()
    $(this).closest('.form-group').find('.custom-file-upload').trigger('click');
});

$(document).ready(function() {
    $('.custom-file-upload').change(function() {
        var filename = $(this).val().split('\\').pop();
        $(this).closest('.form-group').find('.upload-name').text(filename);
    });
});

$(function () {
    Inputmask().mask($(".mask"));
});

$(document).on('change', '.mn-change', function (e) {
    e.preventDefault();
    let select = $(this);
    let model = select.find("option:selected").text().trim()+'/';
    let enrField = select.attr('data-listen');
    $('.label-u-'+enrField).text(model);
});

// region Message Scroll
$(window).on('load', function () {
    let $chatArea = $('.js-messages');
    if($chatArea.length) {
        $chatArea[0].scrollTo(0, $chatArea[0].scrollHeight);
    }
});
// endregion

$(document).on('click', '.js-toggle-side-menu', function (event) {
    event.preventDefault();

    var $sideMenu = $('.js-off-canvas-wrap');
    $sideMenu.toggleClass('move-left');

    if ($sideMenu.hasClass('move-left')) {
        $('.mobile-link').attr('tabindex', '-1').attr('aria-hidden', true);
    } else {
        // $('.js-toggle-side-menu').focus();
        $('.mobile-link').attr('tabindex', '0').attr('aria-hidden', false);
    }
});
